import { fetchApi } from "./fetchApi";

export default {
  async create(data) {
    const response = await fetchApi({
      data,
      method: "post",
      url: `/api/serviceArea`,
    });

    return response.data.result;
  },

  async get(id) {
    const result = await fetchApi({
      method: "get",
      url: `/api/serviceArea/${id}`,
    });

    return result;
  },

  async list({ includeInactive = false } = {}) {
    const response = await fetchApi({
      method: "get",
      params: { includeInactive: includeInactive || undefined },
      url: "/api/serviceArea",
    });

    return response;
  },

  async update({ id, accountManager, active, careSetting, contactPrimary, contactSecondary, name }) {
    const data = { accountManager, careSetting, contactPrimary, contactSecondary, name };
    if (active !== undefined) {
      data.active = active;
    }
    const response = await fetchApi({
      data,
      method: "put",
      url: `/api/serviceArea/${id}`,
    });

    return response.data.result;
  },

  async patchUpdate(id, data) {
    const response = await fetchApi({
      data,
      method: "patch",
      url: `/api/serviceArea/${id}`,
    });

    return response.data.result;
  },
};
